export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'calc(100vh - 20px)',
        paddingBottom: '20px'
    },
    cardContainer: {
        padding: '20px',
        marginLeft: '30px'
    }
})